import AllTherapies from './AllTherapies';

export default AllTherapies;
